import { Component, OnInit, Input } from '@angular/core';
import { NewProductSlider } from '../../../data/slider';
import { Product } from '../../../classes/product';
import { ProductService } from '../../../services/product.service';

@Component({
  selector: 'app-product-box-vertical-slider',
  templateUrl: './product-box-vertical-slider.component.html',
  styleUrls: ['./product-box-vertical-slider.component.scss']
})
export class ProductBoxVerticalSliderComponent implements OnInit {

  @Input() title: string = 'New Product'; // Default
  @Input() type: string = ''; // Default Fashion

  public products : Product[] = [];

  public NewProductSliderConfig: any = NewProductSlider;

  constructor(public productService: ProductService) { 
  }

  ngOnInit(): void {
    this.productService.getProducts.subscribe(response => {
      // Si hay un tipo específico, filtramos por él, de lo contrario mostramos todos los productos
      if (this.type && this.type !== '') {
        // Intentamos filtrar por categoría
        const filteredByCategory = response.filter(item => 
          item.category && item.category.toLowerCase() === this.type.toLowerCase()
        );

        // Si no hay productos filtrados por categoría, intentamos mostrar los más recientes
        if (filteredByCategory.length > 0) {
          this.products = filteredByCategory;
        } else {
          // Si no hay productos de la categoría solicitada, mostramos los últimos 10 productos
          this.products = response.slice(0, 10);
        }
      } else {
        // Si no se especifica un tipo, mostramos los últimos 10 productos
        this.products = response.slice(0, 10);
      }
    });
  }

}
